import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import SaleForm from '../../components/Sale/SaleForm';
import { SellInvoice } from '../../types/sale';
import { useNavigate, useParams } from 'react-router';
import { useSale } from '../../store/saleContext';

const SaleFormPage: React.FC = () => {
    const [editSale, setEditSale] = useState<SellInvoice | undefined>(undefined);
    const { id } = useParams<{ id: string }>();
    const { sale, fetchSale } = useSale();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            fetchSale(id);
        } else {
            setEditSale(undefined);
        }
    }, [id]);

    useEffect(() => {
        if (id && sale) {
            setEditSale(sale);
        } else if (!id) {
            setEditSale(undefined);
        }
    }, [sale, id]);
    return (
        <div style={{ padding: 16 }}>
            <Card title={editSale ? "Edit Sale" : "Add Sale"}>
                <SaleForm
                    editSale={editSale}
                    onFinishEdit={() => navigate('/sales/list')}
                />
            </Card>
        </div>
    );
};

export default SaleFormPage;
